import { render } from "./whoUsView.vue?vue&type=template&id=52e484ad"
import script from "./whoUsView.vue?vue&type=script&lang=js"
export * from "./whoUsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__